export default axios => ({
  getReportRevenue(params) {
    return axios.get('/logs/tune-revenue-report/all', {params})
  },
  exportArchiveRevenue(params) {
    return axios.get('/logs/tune-revenue-report/all/zip', {params, responseType: 'arraybuffer',})
  },
});